/* eslint-disable react/jsx-props-no-spreading */
import { useEffect } from 'react';
import { elementType, string } from 'prop-types';

import { logPerformance } from '../../utilities/PerformanceUtilities';
import PerformanceLog from './PerformanceLog';
import { useAppEnvironment } from '../app/AppSessionProvider';
import { isPgm } from '../../stores/EnvironmentStore';

/**
 * This is a higher-order component that provides performance logging for a route.
 */
export default function RoutePerformanceLog(props) {
    // Use the global app environment when checking personality, since the `useIsPgm` hook will return
    // the local environment, which can be a PLM environment.
    const environment = useAppEnvironment();
    const pgm = isPgm(environment);
    const { path, label, element: Page, ...pageProps } = props;

    useEffect(() => {
        logPerformance(path, pgm);
    }, [path, pgm]);

    return (
        <PerformanceLog label={label}>
            <Page {...pageProps} />
        </PerformanceLog>
    );
}

RoutePerformanceLog.propTypes = {
    path: string.isRequired,
    label: string,
    element: elementType.isRequired,
};

RoutePerformanceLog.defaultProps = {
    label: undefined,
};
